import React, { useEffect, useRef, useState } from "react";
import { MAX_ORDER_QUANTITY, normalizeOrderQuantity } from "../utils/orderQuantity";
import "./CartQuantityControl.css";

export default function CartQuantityControl({ itemId, quantity, productName = "상품", onChange, disabled = false }) {
  const current = normalizeOrderQuantity(quantity);
  const [draft, setDraft] = useState(String(current));
  const editingRef = useRef(false);
  const dirtyRef = useRef(false);
  const cancelledRef = useRef(false);
  const currentRef = useRef(current);
  currentRef.current = current;

  useEffect(() => {
    // A cart refresh can finish while the next quantity is being typed.
    if (!editingRef.current || !dirtyRef.current) setDraft(String(current));
  }, [current]);

  const commit = () => {
    editingRef.current = false;
    const next = disabled || cancelledRef.current || !dirtyRef.current || draft === ""
      ? currentRef.current : normalizeOrderQuantity(draft);
    cancelledRef.current = false;
    dirtyRef.current = false;
    setDraft(String(next));
    if (!disabled && next !== currentRef.current) onChange(next);
  };

  return (
    <div className="cart-quantity" data-cart-quantity={itemId} role="group" aria-label={`${productName} 수량 변경`}>
      <button
        type="button"
        className="cart-quantity__step"
        aria-label={`${productName} 수량 줄이기`}
        disabled={disabled || current <= 1}
        onClick={() => onChange(value => value - 1)}
      >−</button>
      <input
        className="cart-quantity__input"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        aria-label={`${productName} 수량`}
        title="수량 입력 후 Enter 또는 다른 곳을 눌러 적용"
        value={draft}
        disabled={disabled}
        onFocus={() => { editingRef.current = true; dirtyRef.current = false; }}
        onChange={event => {
          if (/^\d*$/.test(event.target.value)) {
            dirtyRef.current = true;
            setDraft(event.target.value);
          }
        }}
        onBlur={commit}
        onKeyDown={event => {
          if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            event.currentTarget.blur();
          } else if (event.key === "Escape") {
            event.preventDefault();
            cancelledRef.current = true;
            event.currentTarget.blur();
          }
        }}
      />
      <button
        type="button"
        className="cart-quantity__step"
        aria-label={`${productName} 수량 늘리기`}
        disabled={disabled || current >= MAX_ORDER_QUANTITY}
        onClick={() => onChange(value => value + 1)}
      >+</button>
    </div>
  );
}
